import type { SVGAttributes } from 'react';

export function CollectedIcon(props: SVGAttributes<SVGSVGElement>) {
	return (
		<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<g opacity="0.4">
				<path
					d="M12.667 18.3336C12.667 19.627 13.667 20.667 14.8937 20.667H17.4003C18.467 20.667 19.3337 19.7603 19.3337 18.627C19.3337 17.4136 18.8003 16.9736 18.0137 16.6936L14.0003 15.2936C13.2137 15.0136 12.6803 14.587 12.6803 13.3603C12.6803 12.2403 13.547 11.3203 14.6136 11.3203H17.1203C18.347 11.3203 19.347 12.3603 19.347 13.6536"
					stroke="currentColor"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path d="M16.0002 10V22" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
			</g>
			<path
				d="M29.3334 16C29.3334 23.36 23.3601 29.3333 16.0001 29.3333C8.64008 29.3333 2.66675 23.36 2.66675 16C2.66675 8.63999 8.64008 2.66666 16.0001 2.66666"
				stroke="currentColor"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M22.6667 4V9.33333H28.0001"
				stroke="currentColor"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M29.3334 2.66666L22.6667 9.33332"
				stroke="currentColor"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}
